import request from './request';

//展商列表
export function exhibitorLists(params) {
    return request({
        url: 'exhibitor/lists',
        method: 'get',
        params
    })
}


//展商详情
export function exhibitorDetail(params) {
    return request({
        url: 'exhibitor/detail',
        method: 'get',
        params
    })
}